<span>
  <ng-content></ng-content>
  <rt-badge *ngIf="isUnread" variant="dot unread"></rt-badge>
  <rt-badge *ngIf="count > 0" margin-left-small-x variant="counter">
    {{ count }}
  </rt-badge>
</span>

<ng-container *ngIf="hrefTarget && href">
  <a [href]="href" target="{{ hrefTarget }}"></a>
</ng-container>
<ng-container *ngIf="!hrefTarget && href">
  <a [href]="href"></a>
</ng-container>
